import { CSSProperties } from 'react';
import { Colors } from '~/themes/colors';

export const Styles = {
  Body: {
    gap: 4,
    marginTop: 4,
  } satisfies CSSProperties,
  BodyRowItem: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    borderRadius: 8,
    padding: '16px',
    cursor: 'default',
    alignItems: 'center',
  } satisfies CSSProperties,
  Header: {
    alignItems: 'center',
    borderBottom: `1px solid ${Colors.neutral_100}`,
    display: 'grid',
    gridTemplateColumns: '1fr',
    padding: '12px 16px',
  } satisfies CSSProperties,
};
